import axios from "axios";
import * as yup from "yup";
import { buildQuery } from "utils/queryUtils";

let schema = yup.object().shape({
    code: yup.string().test("not-blank", "code.required", (code) => code?.length > 0),
    name: yup.string().test("not-blank", "name.required", (name) => name?.length > 0),
    title: yup.string().test("not-blank", "title.required", (title) => title?.length > 0),
    content: yup.string().test("not-blank", "content.required", (content) => content?.length > 0),
    type: yup.string().test("account-register", "type.required", (type) => !!type),
});

export const validateTemplate = (template) => {
    return schema.validate(template, { abortEarly: false });
};

export const findTemplates = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/templates${query}`, {
        headers,
    });
};

export const createTemplate = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/templates`, data, {
        headers,
    });
};

export const updateTemplate = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_IDP_API_URL}/templates/${id}`, data, {
        headers,
    });
};

export const deleteTemplate = (headers, id) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/templates/${id}`, {
        headers: headers,
    });
};

export const deleteTemplates = (headers, ids) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/templates?id=${ids.join()}`, {
        headers: headers,
    });
};
